import AIButton from '@cobliteam/ai/src/ui/AIButton';
import { cn } from '@cobliteam/colib-ui/cn';
import type { IconName } from '@cobliteam/colib-ui/Icon';
import TooltipOnIntent from '@cobliteam/ui-business/components/TooltipOnIntent/TooltipOnIntent';
import { type RailDensity, railShowsTitle } from '../hooks/use-rail-density';
import { getAnimatedIcon } from './animatedIcons';

interface SidebarRailItemProps {
  title: string;
  icon?: IconName;
  isActive?: boolean;
  isHovered?: boolean;
  isAI?: boolean;
  density?: RailDensity;
  showTitle?: boolean;
}

// Sem roteamento nem contexto de dashboard: quem envolve é que navega, então dá pra ter story e teste sem provider.
export function SidebarRailItem({ title, icon, isActive = false, isHovered = false, isAI = false, density = 'full', showTitle = true }: SidebarRailItemProps) {
  const withTitle = railShowsTitle(density, showTitle);

  return (
    <>
      {isAI ? (
        // O tooltip próprio do AIButton diz "Perguntar para o Cobli IA"; no rail sem rótulo quem nomeia é o título da rota.
        <TooltipOnIntent
          render={
            <div className='relative size-8'>
              <AIButton isSelected={isActive} showTooltip={false} size='sm' variant={isActive ? 'solid' : 'soft'} />
            </div>
          }
          disabled={withTitle}
          triggerProps={{ delay: 0 }}
          contentProps={{ side: 'right' }}
        >
          {title}
        </TooltipOnIntent>
      ) : (
        <TooltipOnIntent
          render={
            <button
              aria-label={withTitle ? undefined : title}
              type='button'
              className={cn(
                'flex size-8 cursor-pointer items-center justify-center rounded-lg text-sidebar-foreground group-hover/primary:bg-zinc-300/70 group-hover/primary:text-sidebar-accent-foreground dark:group-hover/primary:bg-sidebar-accent',
                isActive && 'bg-sidebar-primary text-sidebar-primary-foreground group-hover/primary:bg-sidebar-primary group-hover/primary:text-sidebar-primary-foreground'
              )}
            >
              {icon && getAnimatedIcon({ icon, isHovered })}
            </button>
          }
          disabled={withTitle}
          triggerProps={{ delay: 0 }}
          contentProps={{ side: 'right' }}
        >
          {title}
        </TooltipOnIntent>
      )}
      {withTitle && (
        <div
          className={cn(
            'flex cursor-pointer flex-col items-center justify-center font-medium text-[11px] text-sidebar-foreground',
            density === 'compact' && 'leading-3',
            isActive && 'text-sidebar-foreground'
          )}
        >
          {title}
        </div>
      )}
    </>
  );
}
